import { Injectable } from '@angular/core';
import { PermissionBasedAuthGuardService } from 'apps/hospital-admin/src/app/permission/services/permission-based-auth-guard.service';

@Injectable({
  providedIn: 'root',
})
export class RatesManagementAuthGuardService extends PermissionBasedAuthGuardService {
  protected readonly activated = true;
  protected readonly matchPolicy = 'any';
  protected readonly failureUrl: string = 'dashboard';
  protected readonly requiredPermissions = [
    'bulk_create_rate_definitions_permission',
    'bulk_create_approved_rates_permission',
    'bulk_create_demand_authorisers_permission',
    'bulk_create_bank_escalation_authorisers_permission',
    'bulk_create_bank_escalation_levels_permission',
  ];
}
